"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../../config/constants");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _ConditionalComponent = _interopRequireDefault(require("../ConditionalComponent/ConditionalComponent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _classnames = _interopRequireDefault(require("classnames"));

var _generateId = require("../../utils/generateId");

var _function = require("../../utils/type-checks/function");

var _number = require("../../utils/type-checks/number");

var _object = require("../../utils/type-checks/object");

var _setCustomError = _interopRequireDefault(require("../../utils/html-input-validation/setCustomError"));

var _react = _interopRequireWildcard(require("react"));

var _string = require("../../utils/type-checks/string");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormTextField = function FormTextField(props) {
  var additionalDetails = props.additionalDetails,
      autoComplete = props.autoComplete,
      className = props.className,
      clearInputLabel = props.clearInputLabel,
      disabled = props.disabled,
      label = props.label,
      labelHidden = props.labelHidden,
      maxLength = props.maxLength,
      minLength = props.minLength,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClear = props.onClear,
      onFocus = props.onFocus,
      onValidate = props.onValidate,
      passwordReveal = props.passwordReveal,
      pattern = props.pattern,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      required = props.required,
      size = props.size,
      supportingContext = props.supportingContext,
      _props$trimOnBlur = props.trimOnBlur,
      trimOnBlur = _props$trimOnBlur === void 0 ? false : _props$trimOnBlur,
      type = props.type,
      validateOnChange = props.validateOnChange;

  var _useState = (0, _react.useState)((0, _generateId.generateId)()),
      _useState2 = _slicedToArray(_useState, 1),
      additionalDetailsId = _useState2[0];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      id = _useState4[0],
      setId = _useState4[1];

  var _useState5 = (0, _react.useState)(type),
      _useState6 = _slicedToArray(_useState5, 2),
      inputType = _useState6[0],
      setInputType = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isFocused = _useState8[0],
      setIsFocused = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isInteractionStarted = _useState10[0],
      setIsInteractionStarted = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = _slicedToArray(_useState11, 2),
      validationMessage = _useState12[0],
      setValidationMessage = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = _slicedToArray(_useState13, 2),
      validity = _useState14[0],
      setValidity = _useState14[1];

  var _useState15 = (0, _react.useState)((0, _string.isString)(props.value) ? props.value : ""),
      _useState16 = _slicedToArray(_useState15, 2),
      value = _useState16[0],
      setValue = _useState16[1];

  var componentRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setId((0, _string.isStringOfLength)(props.id) ? props.id : (0, _generateId.generateId)());
  }, [props.id]);
  var additionalDetailsElem = null;
  var clearInputElem = null;
  var passwordRevealElem = null;
  var supportingContextElem = null;
  var isDisplayingAdditionalDetails = (0, _object.isObject)(additionalDetails) && (!additionalDetails.onFocus || additionalDetails.onFocus && isFocused);
  var isDisplayingPasswordReveal = type === "password" && (0, _object.isObject)(passwordReveal) && (0, _string.isStringOfLength)(passwordReveal.showImgAlt) && (0, _string.isStringOfLength)(passwordReveal.showImgSrc) && (0, _string.isStringOfLength)(passwordReveal.hideImgAlt) && (0, _string.isStringOfLength)(passwordReveal.hideImgSrc);
  var cmpClassName = (0, _classnames.default)(_defineProperty({
    "cmp-form-text": true,
    "cmp-form-text--isActive": (0, _string.isStringOfLength)(value) || isFocused,
    "cmp-form-text--isFocused": isFocused,
    "cmp-form-text--isInvalid": isInteractionStarted && validity && !validity.valid,
    "cmp-form-text--isPasswordReveal": isDisplayingPasswordReveal
  }, className, (0, _string.isStringOfLength)(className)));

  var handleBlur = function handleBlur(e) {
    setIsInteractionStarted(true);
    setIsFocused(false);
    trimOnBlur && (e.target.value = e.target.value.trim());
    trimOnBlur && setValue(function (current) {
      return current.trim();
    });
    handleValidation(e.target, e.type);
    (0, _function.isFunction)(onBlur) && onBlur(e, componentRef.current);
    setValidity(inputRef.current.validity);
    setValidationMessage(inputRef.current.validationMessage);
  };

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setValue(value);
    validateOnChange && setIsInteractionStarted(true);
    handleValidation(e.target, e.type);
    (0, _function.isFunction)(onChange) && onChange(e, componentRef.current);
    validateOnChange && setValidity(inputRef.current.validity);
    validateOnChange && setValidationMessage(inputRef.current.validationMessage);
  };

  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    (0, _function.isFunction)(onFocus) && onFocus(e, componentRef.current);
  };

  var handleValidation = function handleValidation(eventTarget, eventType) {
    var customHandlerErrorMessage = "";
    var customHandlerValid = true;
    var isBlurEvent = eventType === "blur";
    var isChangeEvent = eventType === "change";

    if ((0, _function.isFunction)(onValidate) && (isBlurEvent || isChangeEvent)) {
      var _onValidate = onValidate(eventTarget, componentRef.current),
          message = _onValidate.message,
          valid = _onValidate.valid;

      customHandlerValid = valid;

      if (!customHandlerValid) {
        customHandlerErrorMessage = message;
      }
    }

    (0, _setCustomError.default)(eventTarget, customHandlerErrorMessage);
  };

  if (isDisplayingAdditionalDetails && (0, _string.isString)(additionalDetails.details)) {
    additionalDetailsElem = /*#__PURE__*/_react.default.createElement("div", {
      className: "cmp-form-text__additional-details"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      className: "cmp-form-text__additional-details__text",
      isRichText: true,
      text: additionalDetails.details
    }));
  }

  if (isDisplayingPasswordReveal) {
    passwordRevealElem = /*#__PURE__*/_react.default.createElement("button", {
      className: (0, _classnames.default)({
        "cmp-form-text__password-reveal": true,
        "cmp-form-text__password-reveal--isActive": type === "password" && inputType === "text"
      }),
      onClick: function onClick() {
        setInputType(function (currentType) {
          return currentType === "password" ? "text" : "password";
        });
      },
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: type === "password" && inputType === "text" ? passwordReveal.hideImgAlt : passwordReveal.showImgAlt,
      src: type === "password" && inputType === "text" ? passwordReveal.hideImgSrc : passwordReveal.showImgSrc
    }));
  }

  if ((0, _string.isStringOfLength)(supportingContext)) {
    supportingContextElem = /*#__PURE__*/_react.default.createElement(_Text.default, {
      className: "cmp-form-text__supporting-context",
      isRichText: true,
      text: supportingContext
    });
  }

  if ((0, _string.isStringOfLength)(clearInputLabel) && (0, _function.isFunction)(onClear)) {
    clearInputElem = /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "cmp-form-text__clear",
      onClick: function onClick(e) {
        setValue("");
        onClear(e);
      },
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("span", null, clearInputLabel));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: cmpClassName,
    ref: componentRef
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    hidden: labelHidden
  }, /*#__PURE__*/_react.default.createElement("span", null, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "cmp-form-text__input-wrap"
  }, /*#__PURE__*/_react.default.createElement("input", {
    "aria-describedby": isDisplayingAdditionalDetails ? additionalDetailsId : null,
    "aria-label": labelHidden ? label : null,
    autoComplete: autoComplete,
    className: "cmp-form-text__input",
    disabled: disabled,
    id: id,
    maxLength: (0, _number.isNumber)(maxLength) && maxLength > 0 ? maxLength : null,
    minLength: (0, _number.isNumber)(minLength) && minLength >= 0 ? minLength : null,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    pattern: (0, _string.isStringOfLength)(pattern) && ["password", "text", "tel"].includes(type) ? pattern : null,
    placeholder: (0, _string.isStringOfLength)(placeholder) ? placeholder : null,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    size: (0, _number.isNumber)(size) && size > 0 ? size : null,
    type: inputType,
    value: value
  }), passwordRevealElem, clearInputElem), supportingContextElem, /*#__PURE__*/_react.default.createElement(_ConditionalComponent.default, {
    condition: isInteractionStarted
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cmp-form-text__input-validity"
  }, validationMessage)), additionalDetailsElem);
}; // Define propTypes;


FormTextField.propTypes = {
  /** additional details to be displayed after the input and error messaging */
  additionalDetails: _propTypes.default.shape({
    /** additional details to be displayed */
    details: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node, _propTypes.default.string]).isRequired,

    /** flag to display additional details on input focus */
    onFocus: _propTypes.default.bool
  }),

  /** autoComplete attribute value on input field, from allowed list */
  autoComplete: _propTypes.default.oneOf(_constants.ALLOWED_AUTOCOMPLETE_ATTR_VALUES),

  /** String to be added to className */
  className: _propTypes.default.string,

  /** String to label the clear button, when available to user */
  clearInputLabel: _propTypes.default.string,

  /** disabled attribute flag for input field */
  disabled: _propTypes.default.bool,

  /** id attribute on input field */
  id: _propTypes.default.string,

  /** label element text */
  label: _propTypes.default.string.isRequired,

  /** flag for hiding label */
  labelHidden: _propTypes.default.bool,

  /** maxLength attribute on input field */
  maxLength: _propTypes.default.number,

  /** minLength attribute on input field */
  minLength: _propTypes.default.number,

  /** name attribute on input field */
  name: _propTypes.default.string,

  /** blur event handler */
  onBlur: _propTypes.default.func,

  /** change event handler */
  onChange: _propTypes.default.func,

  /** clear event handler */
  onClear: _propTypes.default.func,

  /** focus event handler */
  onFocus: _propTypes.default.func,

  /** validate event handler, returns object with boolean 'valid' property and string 'message' property */
  onValidate: _propTypes.default.func,

  /** configurations for password reveal feature */
  passwordReveal: _propTypes.default.shape({
    /** password reveal hide image alternative text */
    hideImgAlt: _propTypes.default.string.isRequired,

    /** password reveal hide image source */
    hideImgSrc: _propTypes.default.string.isRequired,

    /** password reveal show image alternative text */
    showImgAlt: _propTypes.default.string.isRequired,

    /** password reveal show image source */
    showImgSrc: _propTypes.default.string.isRequired
  }),

  /** pattern attribute on input field for types 'password', 'text', 'tel' */
  pattern: _propTypes.default.string,

  /** placeholder attribute for input field */
  placeholder: _propTypes.default.string,

  /** readonly attribute flag for input field */
  readOnly: _propTypes.default.bool,

  /** required attribute flag for input field */
  required: _propTypes.default.bool,

  /** size attribute on input field for types 'email', 'password', 'tel', 'text', 'url' */
  size: _propTypes.default.number,

  /** text to be displayed following input field to provide supporting context */
  supportingContext: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node, _propTypes.default.string]),

  /** flag to trim input value on blur event */
  trimOnBlur: _propTypes.default.bool,

  /** type attribute on input field, from allowed list */
  type: _propTypes.default.oneOf(["email", "password", "search", "tel", "text", "url"]),

  /** flag for validation on change event */
  validateOnChange: _propTypes.default.bool,

  /** value attribute on input field, providing default value */
  value: _propTypes.default.string
}; // Define defaultProps;

FormTextField.defaultProps = {
  autoComplete: "off",
  disabled: false,
  type: "text",
  validateOnChange: false
}; // Export component as default;

var _default = FormTextField;
exports.default = _default;